import { useState, useContext} from "react";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import { DataContext } from "../../context/data-context";
import TollCard from "./TollCard";
import { BsPlusLg } from "react-icons/bs";
import { MdRefresh } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Heading from "../UI/Heading";
import { arrayToCsv } from "../../util/arrayToCsv";
import { BiDownload } from "react-icons/bi";

export default function Tolls() {
  const { vehicles, tolls, fetchTolls } = useContext(DataContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [filteredTolls, setFilteredTolls] = useState();

  const filterTollsHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    const vehicleId = e.target.vehicle.value;
    const startDate = new Date(e.target.from.value);
    const endDate = new Date(e.target.to.value);

    const filteredTolls = tolls.filter((toll) => {
      const tollDate = new Date(toll["Tolled At"]);
      return (
        toll.vehicle.id.includes(vehicleId) &&
        tollDate >= startDate &&
        tollDate <= endDate
      );
    });
    setFilteredTolls(filteredTolls);
    setLoading(false);
  };

  const refreshHandler = () => {
    fetchTolls();
  };

  const getTotalAmount = (tolls) => {
    let total = 0;
    tolls.forEach((toll) => {
      total += Number(toll.Amount.replace("$", ""));
    });
    return total.toFixed(2);
  };

  const downloadCSV = () => {
    if (!filteredTolls) return;
    arrayToCsv(filteredTolls, "tolls");
  };

  const searchBar = (
    <form
      onSubmit={filterTollsHandler}
      className="grid items-end gap-4 p-4 h-fit md:grid-cols-5 bg-stone-800 rounded-xl"
    >
      <div className="grid gap-2 md:col-span-2">
        <label className="text-sm">Vehicle:</label>
        <select className="select" name="vehicle">
          <option value="">All</option>
          {vehicles.map((vehicle) => (
            <option value={vehicle.id} key={vehicle.id}>
              {vehicle.model + " " + vehicle.color + " " + vehicle.license}
            </option>
          ))}
        </select>
      </div>
      <div className="grid gap-2">
        <label className="text-sm">From:</label>
        <input type="date" className="form-input" name="from" required />
      </div>
      <div className="grid gap-2">
        <label className="text-sm">To:</label>
        <input type="date" className="form-input" name="to" required />
      </div>
      <button type="submit" className="btn-primary">
        Search
      </button>
    </form>
  );

  if (loading)
    return (
      <div className="w-full h-screen p-8 overflow-scroll rounded-xl bg-stone-900">
        <LoadingSpinnerWrapper />
      </div>
    );

  return (
    <div className="container grid">
      <Heading title="Tolls">
        <BiDownload
          onClick={downloadCSV}
          className="text-2xl text-white cursor-pointer hover:text-stone-400"
          title="Download CSV"
        />
        <BsPlusLg
          onClick={() => navigate("/tolls/add")}
          className="text-lg text-white cursor-pointer hover:text-stone-400"
          title="Add Payment"
        />
        <MdRefresh
          onClick={refreshHandler}
          className="text-2xl text-white cursor-pointer hover:text-stone-400"
          title="Refresh"
        />
      </Heading>

      {searchBar}

      <div className="overflow-scroll h-[500px]">
        <div className="grid items-start gap-4">
          {filteredTolls &&
            filteredTolls.map((toll, index) => (
              <TollCard toll={toll} key={index} />
            ))}
          {filteredTolls && filteredTolls.length === 0 && (
            <p className="text-center text-stone-400">No tolls found!</p>
          )}
        </div>
      </div>

      <div className="flex items-center justify-end space-x-2">
        {filteredTolls?.length > 0 ? (
          <p className="text-stone-400">
            Total: ${getTotalAmount(filteredTolls)} - {filteredTolls.length}{" "}
            tolls
          </p>
        ) : (
          <p className="text-stone-400">
            Total: ${getTotalAmount(tolls)} - {tolls.length} tolls
          </p>
        )}
      </div>
    </div>
  );
}
